import { Breakpoint, createTheme, ThemeOptions } from '@mui/material';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';

/*
 * // https://mui.com/material-ui/customization/palette
 * primary
 * - main color of the app, for the header background, etc.
 * - brand color
 * - @todo then why does mui used primary.main for input border color and checkbox background?
 *
 * secondary
 * - accent and distinguish
 * - action buttons, selection controls
 * - links, progress bars
 */

declare module '@mui/material/styles' {
  interface Palette {
    subtleGray: string;
    lightGray: string;
    gray: string;
    darkGray: string;
    surface: {
      primary: {
        main: string;
      };
      secondary: {
        main: string;
      };
      info: {
        main: string;
      };
      error: {
        main: string;
      };
      warning: {
        main: string;
      };
      success: {
        main: string;
      };
      disabled: {
        main: string;
      };
    };
    link: {
      main: string;
      hover: string;
    };
    tooltip: {
      background: string;
    };
  }

  interface PaletteOptions {
    subtleGray: string;
    lightGray: string;
    gray: string;
    darkGray: string;
    surface: {
      primary: {
        main: string;
      };
      secondary: {
        main: string;
      };
      info: {
        main: string;
      };
      error: {
        main: string;
      };
      warning: {
        main: string;
      };
      success: {
        main: string;
      };
      disabled: {
        main: string;
      };
    };
    link: {
      main: string;
      hover: string;
    };
    tooltip: {
      background: string;
    };
  }
}

/*
 * Everything that is NOT a color lives here and is shared across every color scheme.
 * A new design-system color scheme should only need to supply a new `PaletteOptions`
 * object (see ./surepath and ./f5) — never touch typography or shape.
 */
export const defaultThemeOptions: Omit<ThemeOptions, 'palette'> = {
  typography: {
    fontFamily: 'Inter, Arial',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 450,
    fontWeightBold: 500,
  },
  shape: {
    borderRadius: 5,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
};

export const getBreakpoint = (size: Breakpoint) =>
  createTheme(defaultThemeOptions).breakpoints.down(size);
